import { SuperViewModalReject } from 'features/withdraw/components/modal/super-admin-reject';
import { useNavigate, useParams } from 'react-router-dom';
import { ROUTES } from 'routes/constants';
// ../components/modal/super-admin-reject
// ../components/modal/withdraw-reject
export const SuperViewReject = () => {
  const navigate = useNavigate();
  const { id } = useParams();

  if (!id) return null;

  const closeModal = () => {
    navigate(ROUTES.SUPER_ADMIN);
  };

  return (
    <SuperViewModalReject id={id} onClose={closeModal} onSuccess={closeModal} />
  );
};
